var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multi-select',{attrs:{"data":_vm.data,"multi-select":_vm.multiSelect,"preselected":_vm.preselected,"is-shortened":_vm.isShortened,"placeholder":_vm.placeholder,"label":_vm.label,"value":_vm.value},on:{"change":_vm.onchange,"input":_vm.oninput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }